// Copyright (c) 2017 Deere & Company

import CreditMemoCellRenderer from '../../shared/report-cell-renderers/credit-memo-cell-renderer';
import DateCellRenderer from '../../shared/report-cell-renderers/date-cell-renderer';
import PinCellRenderer from '../../shared/report-cell-renderers/pin-cell-renderer';
import SpaClaimNumberCellRenderer from '../../shared/report-cell-renderers/spa-claim-number-cell-renderer';
import classNames from '../../shared/constants/ag-grid-class-names';
import dateFilterParams from '../../shared/constants/date-filter-params';
import {translate} from '../../../shared/services/translation-service';

export function getSpecialAllowanceClaimStatusColumnDefinitions() {

    return [
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: SpaClaimNumberCellRenderer,
            colId: 'claimNumber',
            field: 'claimNumber',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CLAIM'),
            width: 150
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'claimStatusDescription ',
            field: 'claimStatusDescription',
            headerClass: classNames.headerClassName,
            headerName: translate('PROCESSING_STATUS_DESCRIPTION'),
            width: 280
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'specialAllowanceDescription ',
            field: 'specialAllowanceDescription',
            headerClass: classNames.headerClassName,
            headerName: translate('SPECIAL_ALLOWANCE_DESCRIPTION'),
            width: 280
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'netAmount',
            field: 'netAmount',
            headerClass: classNames.headerClassName,
            headerName: translate('NET_AMOUNT'),
            width: 150
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'currency',
            field: 'currency',
            headerClass: classNames.headerClassName,
            headerName: translate('CURRENCY'),
            width: 100
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: PinCellRenderer,
            colId: 'pin',
            field: 'pin',
            headerClass: classNames.headerClassName,
            headerName: translate('PIN'),
            width: 200
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'amountOfUse',
            field: 'amountOfUse',
            headerClass: classNames.headerClassName,
            headerName: translate('AMOUNT_OF_USE'),
            width: 150
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'unitOfMeasure',
            field: 'unitOfMeasure',
            headerClass: classNames.headerClassName,
            headerName: translate('UNIT_OF_MEASURE'),
            width: 150
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'failureDate',
            field: 'failureDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('FAILED'),
            width: 130
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'repairDate',
            field: 'repairDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('REPAIRED'),
            width: 130
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'failurePart',
            field: 'failurePart',
            headerClass: classNames.headerClassName,
            headerName: translate('FAILED_PART'),
            width: 130
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'failurePartDescription',
            field: 'failurePartDescription',
            headerClass: classNames.headerClassName,
            headerName: translate('FAILURE_PART_DESCRIPTION'),
            width: 250
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'personResponsible',
            field: 'personResponsible',
            headerClass: classNames.headerClassName,
            headerName: translate('PERSON_RESPONSIBLE'),
            width: 200
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'territory',
            field: 'territory',
            headerClass: classNames.headerClassName,
            headerName: translate('TERRITORY'),
            width: 150
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'reference1',
            field: 'reference1',
            headerClass: classNames.headerClassName,
            headerName: translate('REFERENCE_NUMBER1'),
            width: 150
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'repairNumber',
            field: 'repairNumber',
            headerClass: classNames.headerClassName,
            headerName: translate('REPAIR_NUMBER'),
            width: 150
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'reference2',
            field: 'reference2',
            headerClass: classNames.headerClassName,
            headerName: translate('REFERENCE_NUMBER2'),
            width: 150
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'customerName',
            field: 'customerName',
            headerClass: classNames.headerClassName,
            headerName: translate('CUSTOMER_NAME'),
            width: 150
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'customerContribution',
            field: 'customerContribution',
            headerClass: classNames.headerClassName,
            headerName: translate('CUSTOMER_CONTRIBUTION'),
            width: 180
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'dealerContribution',
            field: 'dealerContribution',
            headerClass: classNames.headerClassName,
            headerName: translate('DEALER_CONTRIBUTION'),
            width: 180
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'companyContribution',
            field: 'companyContribution',
            headerClass: classNames.headerClassName,
            headerName: translate('COMPANY_CONTRIBUTION'),
            width: 180
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'creationDate',
            field: 'creationDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('CREATION_DATE'),
            width: 150
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'originalSubmissionDate',
            field: 'originalSubmissionDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('ORIGINAL_SUBMISSION_DATE'),
            width: 200
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'submissionDate',
            field: 'submissionDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('SUBMISSION_DATE'),
            width: 200
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: CreditMemoCellRenderer,
            colId: 'creditMemo',
            field: 'creditMemo',
            headerClass: classNames.headerClassName,
            headerName: translate('CREDIT_MEMO'),
            width: 130
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'creditMemoDate',
            field: 'creditMemoDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('CREDIT_MEMO_DATE'),
            width: 180
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'account',
            field: 'account',
            headerClass: classNames.headerClassName,
            headerName: translate('ACCOUNT'),
            width: 130
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'accountName',
            field: 'accountName',
            headerClass: classNames.headerClassName,
            headerName: translate('ACCOUNT_NAME'),
            width: 150
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'accountAddress',
            field: 'accountAddress',
            headerClass: classNames.headerClassName,
            headerName: translate('ACCOUNT_ADDRESS'),
            width: 250
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'accountCountry',
            field: 'accountCountry',
            headerClass: classNames.headerClassName,
            headerName: translate('ACCOUNT_COUNTRY'),
            width: 200
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'internalDeereComments',
            field: 'internalDeereComments',
            headerClass: classNames.headerClassName,
            headerName: translate('INTERNAL_DEERE_COMMENTS'),
            width: 300
        }
    ];

}



// WEBPACK FOOTER //
// ./src/reports/special-allowance-claim-status/report-services/column-definitions.js